<!-- <div class="mgo-location-result-services m-top--1">
  <div class="text-result-services">
    <ng-container *ngFor="let service of listOfServices; let last = last">
      <span>{{ service }}&nbsp;<i *ngIf="!last">-&nbsp;</i></span>
    </ng-container>
    <span *ngIf="listOfServices?.length! > 5">
      {{ locationLabels.viewMoreServicesTxt }}
    </span>
  </div>
</div> -->
<div class="service-wrapper" *ngIf="storeServices">
  <div class="services-header">
    <div class="service-text-label">
      {{
        sdfCardLabels?.locationMaps?.storeDetails?.services ||
          "Services"
      }}
    </div>
  </div>
  <div class="services-list">
    <div class="service-item" *ngFor="let service of storeServices">
      {{service}}
    </div>
  </div>
</div>
